import { render, staticRenderFns } from "./ExpenseAreaModal.vue?vue&type=template&id=52cac030&"
import script from "./ExpenseAreaModal.vue?vue&type=script&lang=js&"
export * from "./ExpenseAreaModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports